import React, { useContext, useEffect, useState } from 'react'
// import React, { useState } from 'react'
import UserContainerComponent from '../../components/usersComponents/UserContainerComponent';
import UserDashboardCardComponent from '../../components/usersComponents/UserDashboardCardComponent';
// import Chart from "chart.js/auto";
import { Line } from "react-chartjs-2";
import { LoginContext } from '../../context/LoginContext';
import DataAPI from '../../api/DataApi';

// import webLogin from '../../types/webLogin';

function Dashboard() {
    const dataLogin = useContext(LoginContext);
    const [loading, setloading] = useState(true);

    // console.log(dataLogin.token);
    const labels = ['Mar','Abr','May','Jun','Jul','Ago','Sept'];
    
    let delayed: boolean = false;;
    const data = {
    labels: labels,
    datasets: [{
        label: 'e-CF Emitidos',
        data: [65, 59, 80, 81, 56, 55, 40],
        backgroundColor: [
        '#166534',
        ],
        borderColor: [
        '#c6c6c6',
        ],
        borderWidth: 1,
        pointStyle: 'circle',
        pointRadius: 6,
    }]
    };

    const data2 = {
        labels: labels,
        datasets: [{
            label: 'e-CF Recibidos',
            data: [65, 59, 80, 81, 56, 55, 40],
            backgroundColor: [
            '#01415c',
            ],
            borderColor: [
            '#c6c6c6',
            ],
            borderWidth: 1,
            pointStyle: 'circle',
            pointRadius: 6,
        }]
    };

    useEffect(() => {
        if ( loading ) {
            setloading(false);
            
            
        }
    }, [loading]);
    
    return (
        <UserContainerComponent>
            <div className='px-4 lg:px-8'>
                {/* <p className='font-bold text-lg'>Resumen</p> */}
                <p className='font-bold mt-2 lg:mt-8 text-lg underline'>Dashboard</p>
                <p className='font-bold mt-0 text-lg'>e-CF Emitidos</p>
                
                <div className='flex flex-row gap-4 justify-between overflow-x-auto'>
                    <UserDashboardCardComponent text={'Emitidos Este Mes'} value={'1,000,000'} comment={'Exitosos'}/>
                    <UserDashboardCardComponent text={'Emitidos Mes pasado'} value={'1,000,000'} icon={'cloud_upload'}/>
                    <UserDashboardCardComponent text={'Emitidos Último año'} value={'1,000,000'} />
                    <UserDashboardCardComponent text={'Total e-CF Emitidos'} value={'1,000,000'} />
                </div>
                <div className='mt-10 p-5 bg-white border border-solid border-slate-300 '>
                    <Line
                        width={400}
                        height={300}
                        data={data}
                        options={{
                            maintainAspectRatio: false,
                            responsive: true,
                            plugins: {
                                title : {
                                    display: true,
                                    text: 'e-CF Emitidos ultimos 6 meses',
                                    font: {
                                        size : 16,
                                        weight: 'bold'
                                    }
                                }, legend: {
                                    display: false
                                }
                            }, animation : {
                                onComplete: () => {
                                    delayed = true;
                                },
                                delay: (context) => {
                                    let delay = 0;
                                    // console.log([context.type, context.mode]);
                                    if (context.type === 'data' && context.mode === 'default' && !delayed) {
                                        delay = context.dataIndex * 300 + context.datasetIndex * 100;
                                    }
                                    return delay;
                                },
                                duration: 2000
                            }
                            }
                        }
                    />
                </div>

                <p className='font-bold text-lg'>e-CF Recibidos</p>
                
                <div className='flex flex-row gap-4 justify-between overflow-x-auto'>
                    <UserDashboardCardComponent text={'Recibidos Este Mes'} color={'blue'} value={'1,000,000'} icon={'cloud_download'} />
                    <UserDashboardCardComponent text={'Recibidos Mes Pasado'} color={'blue'} value={'1,000,000'} icon={'cloud_download'} />
                    <UserDashboardCardComponent text={'Recibidos Último año'} color={'blue'} value={'1,000,000'} icon={'cloud_download'} />
                    <UserDashboardCardComponent text={'Total e-CF Recibidos'} color={'blue'} value={'1,000,000'} icon={'cloud_download'} />
                </div>

                <div className='mt-10 p-5 bg-white border border-solid border-slate-300 '>
                    <Line
                        width={400}
                        height={300}
                        data={data2}
                        options={{
                            maintainAspectRatio: false,
                            responsive: true,
                            plugins: {
                                title : {
                                    display: true,
                                    text: 'e-CF Recibidos ultimos 6 meses',
                                    font: {
                                        size : 16,
                                        weight: 'bold'
                                    }
                                }, legend: {
                                    display: false
                                }
                            }
                            }
                        }
                    />
                </div>

                <p className='font-bold text-lg'>Aprobaciones Comerciales</p>
                
                <div className='flex flex-row gap-4 justify-between overflow-x-auto'>
                    <UserDashboardCardComponent text={'Enviadas Este Mes'} color={'gray'} value={'1,000,000'} icon={'cloud_done'} />
                    <UserDashboardCardComponent text={'Total Enviadas'} color={'gray'} value={'1,000,000'} icon={'cloud_done'} />
                    <UserDashboardCardComponent text={'Recibidas Este Mes'} color={'gray'} value={'1,000,000'} icon={'cloud_done'} />
                    <UserDashboardCardComponent text={'Total Recibidas'} color={'gray'} value={'1,000,000'} icon={'cloud_done'} />
                </div>

                <div className='mt-12'></div>
            </div>
        </UserContainerComponent>
    );
}

export default Dashboard;